// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_Vy9Pl","clearfix":"reset_clearfix_vUdm8"};